import React, { useEffect, useRef, useContext } from "react";
import styled from "styled-components";
import { Map, View } from "ol";
import { fromLonLat } from "ol/proj";
import TileLayer from "ol/layer/Tile";
import OSM from "ol/source/OSM";
import { LocationContext } from "../locationData";
import CircleMarker from "./CircleMarker";

export default function OlMap(props) {
  const [loading, location] = useContext(LocationContext);
  const map = useRef();

  useEffect(() => {
    let olmap = new Map({
      target: map.current,
      layers: [new TileLayer({ source: new OSM() })],
      view: new View({
        center: fromLonLat([props.lon, props.lat]),
        zoom: props.zoom || 6,
      }),
    });

    if (!loading) {
      location.locations.map((eachLocation) => {
        return CircleMarker([eachLocation[1], eachLocation[0]], olmap);
      });
    }
  }, [props.lat, props.lon, props.zoom, loading, location.locations]);

  return (
    <>
      <StyledMapWrapper ref={map} />
    </>
  );
}

const StyledMapWrapper = styled.div`
  width: 100%;
  height: 100%;
  background-color: lightblue;
  background-repeat: no-repeat;
  display: flex;
  justify-content: center;
  align-items: center;
`;
